// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"4362d44df93b90487b6a","339":"d0557de10628cbe98f62"}[chunkId] + ".js";
};